import { Filter } from 'components/FilterDrawer/FilterDrawer.config'

export interface FetchEOGraphDataProps {
  caseId: string
  zoneEndpoint: string
  localCountry?: string
  filters: Filter[]
  // Employee counts from entity index to use for most recent year in trendlines
  // (ensures trendline matches header exactly)
  employeesLocal?: number
  employeesAbroad?: number
}

export type FilterOptions = Record<string, { value: any; label: string }[]>

export enum EmployeeOverviewDataKeys {
  localAmount = 'totalLocalAmount',
  restOfTheWorldAmount = 'totalRestOfTheWorldAmount',
}
